import { ReactElement, ReactNode } from 'react';

type Spacing = 'none' | 'xs' | 's' | 'm' | 'l' | 'xl' | 'xxl';

type DetailsItemProps = {
  label: string;
  children: ReactNode;
  gap?: Spacing;
  paddingTop?: Spacing;
};

const GAP_CLASS_MAP: Record<Spacing, string> = {
  none: '',
  xs: 'gap-xs',
  s: 'gap-s',
  m: 'gap-m',
  l: 'gap-l',
  xl: 'gap-xl',
  xxl: 'gap-xxl',
};

const PADDING_TOP_CLASS_MAP: Record<Spacing, string> = {
  none: '',
  xs: 'p-top-xs',
  s: 'p-top-s',
  m: 'p-top-m',
  l: 'p-top-l',
  xl: 'p-top-xl',
  xxl: 'p-top-xxl',
};

export function DetailsItem({
  label,
  children,
  gap = 'xl',
  paddingTop = 'xl',
}: DetailsItemProps): ReactElement {
  const gapClass = GAP_CLASS_MAP[gap as keyof typeof GAP_CLASS_MAP];
  const paddingTopClass =
    PADDING_TOP_CLASS_MAP[paddingTop as keyof typeof PADDING_TOP_CLASS_MAP];

  return (
    <div className={`row ${paddingTopClass}`} data-testid="details-item">
      <div className="col-3">
        <h3 className="body-bold">{label}</h3>
      </div>
      <div
        className={`col-9 flex flex__dir--column ${gapClass}`}
        data-testid="details-item-content"
      >
        {children}
      </div>
    </div>
  );
}
